import React from "react";
import { useTranslation } from "react-i18next";

import { InfoNotice } from "../InfoNotice";
import FormItem from "../FormItem";
import { sizes } from "../../../../../constant/styles";

/**
 * Native JSON field type `infoNotice`: renders the shared InfoNotice (the bordered light-blue info
 * box) from a translation key — the JSON-renderer equivalent of the inline
 * `<FormItem><InfoNotice text={t(key)} fontSize={sizes.medium} /></FormItem>` the hand-written
 * sections used (e.g. the practice-NPI portal notice next to the NPI field). Display-only: it binds
 * no value to the FE->BE bundle. The empty FormItem wrapper mirrors the old markup so the notice
 * lines up with the labelled input beside it.
 *
 * FormJson usage:
 *   { "type": "infoNotice", "name": "", "colSize": 16,
 *     "dedicatedFieldProps": { "textKey": "<i18n key>" } }
 */
export const InfoNoticeField = ({ textKey, fontSize }) => {
  const { t } = useTranslation();

  return (
    <FormItem>
      <InfoNotice text={t(textKey)} fontSize={fontSize || sizes.medium} />
    </FormItem>
  );
};

export default InfoNoticeField;
